<template>
  <div class="hyper-block-view">
    <div :class="['tit_box', `bg${ vers }`]">
      <div class="versions clearfix">
        <div :class="['clearfix',{'active': vers == 1}]">
          <div class="fr">
            <span class="tit" @click="setVers(1)">
              {{$t('tit_one')}}
            </span>
          </div>
        </div>
        <div :class="['clearfix',{'active': vers == 2}]">
          <div class="fl">
            <span class="tit" @click="setVers(2)">
              {{$t('tit_two')}}
            </span>
          </div>
        </div>
      </div>
      <div class="b">
        <div v-show="vers == 1" class="container">
          <div class="dis">
            <!-- <h1 class="h1" v-text="$t('h1')"></h1> -->
            <div class="chain-information">
              <div class="box">
                <div>
                  <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('HyperchainSpaceHeight')} icon`">
                  <span class="fl" v-text="$t('HyperchainSpaceHeight')">链空间高度</span>
                </div>
                <div id="Hyperchain-height">
                  <span class="fl"></span>
                  <span class="fl cont" v-text="hyperchain_height"></span>
                </div>
                <div>
                  <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('HyperchainSpaceHeight')} icon`">
                  <span class="fl" v-text="$t('SpaceHeight')">链空间高度</span>
                </div>
              </div>
              
              <div class="box">
                <div>
                  <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('Concurrency')} icon`">
                  <span class="fl"  v-text="$t('Concurrency')">区块链数</span>
                </div>
                <div id="Blockchains">
                  <span class="fl"></span>
                  <span class="fl cont" v-text="blockchains"></span>
                </div>
                <div>
                  <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('Concurrency')} icon`">
                  <span class="fl"  v-text="$t('Concurrency')">区块链数</span>
                </div>
              </div>
              <div class="box">
                <div>
                  <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('Nodes')} icon`">
                  <span class="fl" v-text="$t('Nodes')">节点数</span>
                  <!-- <a class="fl a" :href="`./nodemap.html?lang=${ $i18n.locale }`" v-text="$t('NodeMap')">节点地图</a> -->
                  <router-link class="fl a" to="/node_map" v-text="$t('NodeMap')">节点地图</router-link>
                </div>
                <div id="Nodes">
                  <span class="fl"></span>
                  <span class="fl cont" v-text="nodes"></span>
                </div>
                <div>
                  <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('Nodes')} icon`">
                  <router-link class="fl a" to="/node_map" v-text="$t('Nodes')">节点数</router-link>
                  <!-- <a class="fl" :href="`./nodemap.html?lang=${ $i18n.locale }`"><img src="@/../public/static/img/blockView/Earth.png" alt=""></a> -->
                  <!-- <router-link class="fl" to="/node_map"><img src="@/../public/static/img/blockView/Earth.png" alt=""></router-link> -->
                </div>
              </div>
              <div class="box">
                <div>
                  <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('Apps')} icon`">
                  <span class="fl" v-text="$t('Apps')">App 数量</span>
                </div>
                <div id="Apps">
                  <span class="fl"></span>
                  <span class="fl cont" v-text="apps"></span>
                </div>
                <div>
                  <img class="fl" src="@/../public/static/img/blockView/icon.png" :alt="`${$t('Apps')} icon`">
                  <span class="fl"  v-text="$t('Apps')">App 数量</span>
                </div>
              </div>
            </div>
            <div ref="inputGroup" class="input-group clearfix">
              <span class="fl" v-text="$t('Search')">搜索</span>
              <input type="text" v-model="val" @keyup.enter="serch" @focus="$refs.inputGroup.className = 'input-group clearfix hoverInputBorderStyle';" @blur="$refs.inputGroup.className = 'input-group clearfix';"/>
              <button id="search-btn" @click="serch()"><img src="@/../public/static/img/blockView/search.png" alt="search"></button>
            </div>
            <div class="tips" v-text="$t('Tips')">
              提示：搜索超块，请输入超块号，如11633； 搜索子链，请输入子链号，如116331,2；搜索子链区块，请输入区块号，如116331,2,5。
            </div>
            <div class="hint" :style="messageBol?'visibility:visible;':''">
              <img src="@/../public/static/img/blockView/iconHint.png" class="img"><span v-text="message"></span>
            </div>
            <div class="tc beian">苏网信备3205062236094903001x号</div>
          </div>
        </div>
        <div v-show="vers == 2" class="container nft_search">
          <div class="nft_info tc">
            <div class="nft_info_box">
              <div class="key" v-text="$t('NFT_key1')">累计用户数量</div>
              <div class="value">2,000,000+</div>
            </div>
            <div class="nft_info_box">
              <div class="key" v-text="$t('NFT_key2')">日均交易数量</div>
              <div class="value">100,000+</div>
            </div>
            <div class="nft_info_box">
              <div class="key" v-text="$t('NFT_key3')">铸造藏品</div>
              <div class="value">2,800,000+</div>
            </div>
          </div>
          <div class="nft_search_group">
            <input
             class="nft_search_inp" 
             @keydown.enter="nft_search()"
             :placeholder="$t('NFT_placeholder')"
             v-model="nft_params" 
             type="text" />
            <img class="nft_search_img" src="./../../public/static/img/blockView/search.svg" @click="nft_search()" alt="NFT 搜索">
          </div>
          <!-- <div class="tc">切换至 <a href="https://api.daogram.cn/">高级搜索</a></div> -->
          <div class="tc beian">苏网信备32050622360949030028号</div>
        </div>
      </div>
    </div>
    <div v-show="vers == 1" class="container">
      <div class="dis">
        <div class="crumbs">
          <router-link v-show="$route.name == 'HyperblockView'||$route.name == 'LocalchainView'||$route.name == 'LocalblockView'" :to="`/`" v-text="$t('HyperBlockList')">
            超块列表
          </router-link>
          <span v-show="$route.name == 'HyperblockView'||$route.name == 'LocalchainView'||$route.name == 'LocalblockView'">/</span>
          <router-link 
          v-show="$route.name == 'LocalchainView'||$route.name == 'LocalblockView'" 
          :to="`/HyperblockView/${ $route.params.hid }`"
          v-text="$t('HyperBlockMsg')">
            超块信息
          </router-link>
          <span v-show="$route.name == 'LocalchainView'||$route.name == 'LocalblockView'">/</span>
          <router-link v-show="$route.name == 'LocalblockView'" :to="`/LocalchainView/${ $route.params.hid }/${ $route.params.chainNum }`" v-text="$t('LocalChainMsg')">
            子链信息
          </router-link>
          <span v-show="$route.name == 'LocalblockView'">/</span>
        </div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data(){
    return {
      blockchains: 0,
      hyperchain_height: 0,
      nodes: 0,
      val: '',
      message: '搜索信息无效。',
      messageBol: false,
      vers: localStorage.getItem('vers') || 1,
      apps: 0,
      nft_params: '',
    }
  },
  created(){
    this.init();
    let { route } = this.$route.query;
    if(route == 'NFT'){
      this.setVers(2);
    }else if(route == 'Block'){
      this.setVers(1);
    }
  },
  methods:{
    init(){
      var _this = this;
      _this.$http({
        url:'hyperchain/info',
        baseURL: process.env.VUE_APP_CURRENTMODE,
        method: 'get',
      }).then((res)=>{
        var data = res.data;
        if(data.ret == 200){
          _this.blockchains = data.data.blockchains;
          _this.hyperchain_height = data.data.hyperchain_height;
          _this.nodes = data.data.nodes;
          
          this.apps = data.data.apps
        }
      })
    },
    setVers(vers){
      let _this = this;
      _this.vers = vers;
      localStorage.setItem('vers',vers);
      _this.init();
    },
    serch(){
      var lang = this.$i18n.locale;
      this.$http({
        url:`hyperchain/search?keyword=${ this.val }`,
        baseURL: process.env.VUE_APP_CURRENTMODE,
        method: 'get',
      }).then((res)=>{
        var data = res.data;
        console.log(data);
        if(data.ret == 200){
          this.messageBol = false;
          var dat = data.data;
          switch(dat.type){
            case "hyperblock":
              this.$router.push(`/HyperblockView/${ dat.hid }`);
            break;
            case "localchain":
              this.$router.push(`/LocalchainView/${ dat.hid }/${ dat.chain_num }`);
            break;
            case "localblock":
              this.$router.push(`/LocalblockView/${ dat.hid }/${ dat.chain_num }/${ dat.id }`);
            break;
            default:
              this.$router.push(`/`)
            break;
          }
        }else if(data.ret == 400001){
            this.messageBol = true;
            if(+this.val < this.hyperchain_height){
               if(lang == "zh"){
                  this.message = "数据暂未找到，已请求数据同步，请稍后重试";
               }else{
                  this.message = "Data not found,  synchronization request sent, please try later.";
               }
            }else{
               if(lang == "zh"){
                  this.message = "查询的超块还未生成";
               }else{
                  this.message = "Queried  Hyperblock have not been generated";
               }
            }
         }else if(data.ret == 400002){
            this.messageBol = true;
            if(lang == "zh"){
               console.log(2)
               this.message = "子链信息未找到";
            }else{
               this.message = "Subchain information not found";
            }
         }else if(data.ret == 400003){
            this.messageBol = true;
            if(lang == "zh"){
               console.log(3)
               this.message = "子链区块信息未找到";
            }else{
               this.message = "Subchain block information not found";
            }
         }else if(data.ret == 400004){
            this.messageBol = true;
            if(lang == "zh"){
               console.log(4)
               this.message = "搜索信息无效。";
            }else{
               this.message = "invalid input.";
            }
         }
      })
    },
    nft_search(){
      window.location.href = `https://api.daogram.cn/certificate/index.html?nft_params=${ this.nft_params }`
    }
  }
}
</script>
<style lang="scss" src="./../../public/static/scss/HyperblockView.scss"></style>
<style scoped lang="scss">
  .b{
    // background: #396695;
    .nft_search{
      margin-top: 80px;
      overflow: hidden;
      .beian{
        margin-top: 160px;
      }
      .nft_info{
        display: flex;
        .nft_info_box{
          flex: 1;
          line-height: 1;

          .key{
            font-size: 24px;
            color: #e6e6e6;
          }
          .value{
            margin-top: 32px;
            color: #fff;
            font-size: 36px;
          }
        }
      }
      .nft_search_group{
        width: 800px;
        height: 54px;
        margin: 90px auto 0;
        position: relative;
        border: none;
        background: #fff;
        outline: none;
        border-radius: 1000px;
        .nft_search_inp{
          border-radius: 1000px;
          width: 800px;
          line-height: 54px;
          font-size: 18px;
          padding: 0 20px;
          position: absolute;
          z-index: 2;
          left: 0;
          top: 0;
        }
        .nft_search_img{
          position: absolute;
          z-index: 3;
          right: 20px;
          top: 10px;
          width: 34px;
          display: block;
        }
      }
      
    }
  }
  .phone{
    display: none;
  }
  .hoverInputBorderStyle {
    border-color: #e37200;
  }
  .default{
    text-align: center;
    img{
      margin: 60px auto -130px;
    }
  }
  .default_text{
    color: #4b5666;
    font-size: 30px;
    text-align: center;
    opacity: .6;
    margin-top: 160px;
    margin-bottom: 100px;
  }
  .crumbs{
    margin: 20px 0;
    font-size: 14px;
    color: #888888;
    span{
      margin: 0 6px;
    }
    a{
      color: #888888;
      &:hover{
        color: #e37200;
        text-decoration: underline;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .b{
      .nft_search{
        min-height: 5.3rem;
        .nft_info{
          .nft_info_box{
            .key{
              font-size: 14px;
              font-weight: 600;
            }
            .value{
              margin-top: 16px;
              font-size: 18px;
            }
          }
        }
        .nft_search_group{
          width: 100%;
          height: 40px;
          margin: 90px auto 0;
          position: relative;
          border: none;
          background: #fff;
          outline: none;
          .nft_search_inp{
            width: 100%;
            line-height: 40px;
            font-size: 16px;
            padding: 0 20px;
            position: absolute;
            z-index: 2;
            left: 0;
            top: 0;
          }
          .nft_search_img{
            position: absolute;
            z-index: 3;
            right: 20px;
            top: 10px;
            width: 20px;
            display: block;
          }
        }
        
      }
    }
    .phone{
      display: inline;
    }
    .crumbs{
      font-size: .28rem;        
    }
    .default{
      text-align: center;
      img{
        margin: .60rem auto -1.30rem;
        width: 2.76rem;
        height: 2.86rem;
      }
    }
    .default_text{
      font-size: .36rem;
      text-align: center;
      opacity: .6;
      margin-top: 1.60rem;
    }
  }
  
</style>

